import { IconV2 } from '@withjoy/joykit';

export interface ProductSelectionDialogProps {
  isOpen: boolean;
  onClose: () => void;
  refreshDashboardPreview?: () => void;
}

export enum Product {
  Website = 'website',
  Registry = 'registry',
  Invitations = 'invitation_save_the_dates',
  GuestList = 'guestList_rsvp'
}

export interface ProductOption {
  id: Product;
  label: string;
  icon: typeof IconV2;
}

export type SelectedValue = {
  [key in Product]?: boolean;
};
